import React from 'react';
import PropTypes from 'prop-types';

export default function IcEdit({ className }) {
  return (
    <svg className={className} fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.242 5.58543L5.27044 11.5584C4.95004 11.8788 4.54859 12.1061 4.10901 12.216L1.81801 12.7887C1.45182 12.8803 1.12013 12.5486 1.21167 12.1824L1.78442 9.89138C1.89432 9.4518 2.12162 9.05035 2.44201 8.72995L8.41355 2.757L11.242 5.58543ZM12.6569 1.34349C13.4379 2.12454 13.4379 3.39087 12.6569 4.17192L11.9491 4.87832L9.12066 2.04989L9.82847 1.34349C10.6095 0.562444 11.8759 0.562444 12.6569 1.34349Z" fill="white"/>
    </svg>
  );
}

IcEdit.propTypes = {
  className: PropTypes.string
};
